"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW = void 0;
var VIEW = {
  TEXT__TOTAL_AMOUNT: 'singleOrder-value-totalAmount',
  BUTTON__OUTLET_INFO: 'singleOrderView-button-outletInfo',
  BUTTON__EXPORT: 'singleOrderView-div-export'
};
exports.VIEW = VIEW;